var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"wifi-button",on:{"click":function($event){_setup.wifiModel.modal = true}}},[_vm._v("\n  Wi-Fi\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }